import {config as engagementNameConfig} from './EngagementName';
import {config as clientNameConfig} from './ClientName';
import {config as roleTypeConfig} from './RoleType';

export default (labels) => [engagementNameConfig(labels), clientNameConfig(labels), roleTypeConfig(labels)];
